import React from 'react';
import { Toaster } from 'react-hot-toast';
import { GameAudioProvider } from './components/GameAudioProvider';
import { StorageProvider } from './components/LocalStorage';
import { ApiProvider } from './components/ApiIntegration';
import { DesignSystemProvider } from './components/DesignSystem';
import { CollisionProvider } from './components/CanvasGame';
import { Animations } from './components/Animations';
import DodgeTheRainGame from './components/DodgeTheRainGame';

function App() {
  return (
    <DesignSystemProvider>
      <StorageProvider>
        <ApiProvider>
          <GameAudioProvider>
            <CollisionProvider>
              <Animations>
                <Toaster position="top-center" />
                <DodgeTheRainGame />
              </Animations>
            </CollisionProvider>
          </GameAudioProvider>
        </ApiProvider>
      </StorageProvider>
    </DesignSystemProvider>
  );
}

export default App;